module.exports = __webpack_public_path__ + "img/caigou2.82cea24e.png";